module.exports = __webpack_public_path__ + "img/EllaChenImg.4ddaa4a2.jpg";